<script lang="ts">
	export let fill = "#bcbfc3";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 24 25.195">
	<g>
		<path
			d="M120.563 158.408a4.42 4.42 0 0 0 4.036-2.626 6.373 6.373 0 0 1-2.23-4.851 5.9 5.9 0 0 1 .07-.927 4.412 4.412 0 1 0-1.876 8.4z"
			transform="translate(-116.019 -145.751)"
			fill={fill} />
		<path
			d="M147.372 155.824a4.413 4.413 0 1 0 4.02-6.239 4.362 4.362 0 0 0-1.812.391 6.251 6.251 0 0 1 .075.954 6.388 6.388 0 0 1-2.283 4.894z"
			transform="translate(-131.814 -145.751)"
			fill={fill} />
		<path
			d="m139.822 175.742-1.388-4.915a1.922 1.922 0 0 0-1.815-1.426h-3.05a1.876 1.876 0 0 0-1.764-1.276h-7.629a1.886 1.886 0 0 0-1.764 1.276h-3.228a1.922 1.922 0 0 0-1.815 1.426l-1.388 4.915a2.064 2.064 0 0 0 .295 1.764 1.839 1.839 0 0 0 1.52.8h2.638l-.005.016a2.068 2.068 0 0 0 .361 1.694 1.847 1.847 0 0 0 1.484.756h11.436a1.847 1.847 0 0 0 1.484-.756 2.068 2.068 0 0 0 .361-1.694l-.005-.016h2.455a1.838 1.838 0 0 0 1.52-.8 2.064 2.064 0 0 0 .297-1.764zm-1.815 1.5h-2.689l-1.489-6.764h2.79a.884.884 0 0 1 .839.659l1.393 4.915a.917.917 0 0 1-.844 1.185zm-3.5 1.072.056.257a.916.916 0 0 1-.854 1.136h-11.433a.916.916 0 0 1-.854-1.136l.056-.257.117-.536.117-.536 1.489-6.764.117-.536.005-.021a.911.911 0 0 1 .31-.515.829.829 0 0 1 .544-.2h7.629a.842.842 0 0 1 .549.2.97.97 0 0 1 .31.515l.005.021.117.536 1.489 6.764.117.536zm-17.551-2.262 1.388-4.915a.884.884 0 0 1 .839-.659h2.968l-1.484 6.764H117.8a.915.915 0 0 1-.84-1.195z"
			transform="translate(-115.903 -155.58)"
			fill={fill} />
		<path
			d="M135.08 152.811a5.325 5.325 0 0 0 5.328-5.328c0-.113-.005-.22-.011-.327a5.328 5.328 0 0 0-10.64.054v.005c-.005.091-.005.177-.005.268a5.332 5.332 0 0 0 5.328 5.328z"
			transform="translate(-122.992 -142.155)"
			fill={fill} />
	</g>
</svg>

<style lang="scss">
</style>
